import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalBikeRelatedProducts" })
export default class GlobalBikeRelatedProducts extends Vue {
    public localizer: any = Localizer;
    public relatedProducts: any[] = [];

    @Prop() readonly bremboCode: string;
    @Prop() readonly productType: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getRelatedProduct();
    }

    public async getRelatedProduct() {
        try {
            const response = (await Axios.post(this.routes.CatalogueGlobalBikeDetail_GetRelatedProducts, { bremboCode: this.bremboCode, productType: this.productType })).data;
            this.relatedProducts = response;
        } catch (error) {
            this.relatedProducts = [];
        }
    }

    public getProductLabel(relatedProduct: string) {
        let label = null;
        if (relatedProduct == "Pad") {
            label = this.localizer["Catalogue.Common.List_Pad"];
        }

        return label;
    }
}